import React from 'react';
import PageWrapper from './PageWrapper';
import styled from 'styled-components'
import { GSButton, PaleBox, FlexContainer } from './Components';

const Title = styled.div`
  color: #FFF;
  text-align: center;
  font-family: Inter;
  font-size: 35px;
  font-style: normal;
  font-weight: 700;
`

const Body = styled.div`
  white-space: pre-line;
  color: #FFF;
  font-family: Inter;
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  width: 70%;
  padding-top: 3rem;
`

const WelcomeContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  padding-bottom: 0px;
  margin-bottom: -15px;
  background-size: cover;
  color: #FFFFFF;
  padding-top: 200px;

  .login-link {
    text-decoration: underline;
    color: white;

    &:hover {
      color: grey;
    }

  &__buttons {
    align-items: center;
    display: flex;
    flex-direction: column;
    margin: 40px 0 60px;

    a:first-child {
      margin-bottom: 20px;
    }
  }
`

const LowerContainer = styled.div`
    background-size: cover;
    flex-shrink: 0; 
    display: flex;
    flex-direction: column;
    align-items: center;

    .login-link {
      text-decoration: underline;
      color: black;

      &:hover {
        color: DarkGray;
      }
`;

const LowerContainerBox = styled.div`
    display: flex;
    color: #204860; 
    padding: 3rem;
    flex-direction: column;
    width: 70rem;
    flex-shrink: 0; 
    margin-top: 7rem;
    margin-bottom: 7rem;
    background-color: #FFF;
    border: 1px solid rgba(32, 72, 96, 0.25);


    .login-link {
      text-decoration: underline;
      color: black;

      &:hover {
        color: DarkGray;
      }
`;


const TextDiv = styled.div`
  margin-bottom: 1rem;
  text-align: center;
`

const BoxContainer = styled.div`
  display: flex;
  flex-direction: row;
  text-align: center;
  justify-content: center;
  margin-bottom: 2rem;
`;

class WelcomeScreen extends React.Component {
    constructor(props) {
      super(props);
    }
  
    // Renderers
  
    renderLoginButtons() {
      return (
        <TextDiv>
          <a href="/profile/oauth" style={{'textDecoration': 'none'}}><GSButton>Sign up with Google</GSButton></a>
          <a href="/profile/oauth" className="login-link">Already have an account? Login</a>
        </TextDiv>
      );
    }
  
    render() {
      const img1style={
        backgroundColor: "#2b4758",
        backgroundRepeat: "no-repeat",
        backgroundImage: "url(https://mixer-static.gridspace.com/labsstatic/gridspace_crowd/bg-blackpoly.png)",
      };
      const img2style={
        backgroundColor: "#fff",
        backgroundRepeat: "no-repeat",
        backgroundImage: "url(https://mixer-static.gridspace.com/labsstatic/gridspace_crowd/SpectrogramBackground.jpg)",
      };  
      return (
        <PageWrapper isAdmin={this.props.isAdmin} noContainer={true}>
          <WelcomeContainer style={img1style}>
            <FlexContainer>
              <Title>Welcome to Gridspace Mixer Lab</Title>
              <Body>
                Gridspace is working on cutting edge machine learning for exciting speech analysis and automation applications.
                Our Voice Bot, Grace, works on our custom internal LLMs and Speech recognition and generation models.
                In order to do this, we need to collect data, and lots of it.
                Gridspace Mixer is our crowd-work platform to help build these systems. Our contributors do important work in helping us curate training data and run evaluations for our models.
              </Body>
              <div className="row">
                {this.renderLoginButtons()}
              </div>
              <TextDiv>
                <h3>Sample Tasks</h3>
              </TextDiv>
              <BoxContainer>
                <PaleBox>
                  <h3>Actor Role Play</h3>
                  {/* <br/> */}
                  Put on your improv hat and simulate short conversations with another live caller.
                </PaleBox>
                <PaleBox>
                  <h3>Bot Testing</h3>
                  {/* <br/> */}
                  Help test and improve our automated voice bot applications.
                </PaleBox>
              </BoxContainer>
            </FlexContainer>
          </WelcomeContainer>

          <LowerContainer style={img2style}>
            <LowerContainerBox>
              <div className="welcome-view__qa-item">
                <h2>What is Gridspace?</h2>
                <p>
                  <a href="www.gridspace.com">Gridspace</a> makes software for speech analytics and automation. We combine new techniques in the fields of speech recognition, natural language processing, and artificial intelligence.
                  Check out our YouTube channel <a href="https://www.youtube.com/@GridspaceInc">here</a>.
                </p>
              </div>

              <div className="faq-view__qa-item">
                <h2>What is Gridspace Mixer?</h2>
                <p>
                  <a href="https://mixerlab.gridspace.com/">MixerLab</a> is our in-house data collection platform, 
                  where we collect both human-to-human and human-to-bot conversations.
                </p>
                <p>
                  We will initially have two types of <b>Actor tasks</b>: <b>human-to-human call center role-play, hosted in Actor Sessions, and bot testing, hosted in Bot Sessions.</b> 
                </p>
                <p>
                  During an Actor Session, you'll be given instructions to call and interact with another live caller, 
                  along with detailed instructions for role-playing various call-center scenarios. 
                  These sessions occur at scheduled times, usually lasting an hour, 
                  where we aim to have a variety of people calling in to complete our tasks. 
                  In a Bot Session, you'll be provided with a phone number to call and engage with our voice bot, Grace. 
                  Bot testing tasks can be completed any time they are available.</p>
                <p>
                  <b>Slack tasks</b>: Our data labeling tasks are hosted through the Slack app. 
                  Upon joining Mixer, you'll receive an email invitation to join our MixerLab Slack channel, and you'll continue from there. 
                </p>
                <p>You can track both your performance and payments for Actor and Slack tasks on your <a href="/profile/me">profile</a>.</p>
                <p>Your contribution is vital in helping us curate training data and run evaluations for our models.</p>
              </div>

              <div className="welcome-view__qa-item">
                <h2>Why should I use Mixer instead of MTurk?</h2>
                <p>
                  1. We pay better.<br/>
                  2. Our tasks are more fun.<br/>
                  3. You'll help build the next generation of state-of-the-art speech technology.
                </p>
              </div>

              <div className="faq-view__qa-item">
                <h2>What do I need to get started?</h2>
                <p>
                  You'll need a Google account which works with PayPal. Please sign in to MixerLab with your Google account and connect your Google account email with your PayPal account on your <a href="/profile/me">profile</a>.
                </p>
                <p>
                  For Actor tasks, you'll need to provide your phone number at registration. 
                  In Actor Sessions, you'll need a phone to call into mixer, and a laptop with a headset to enact the agent role. </p>
                <p>
                  For Slack tasks, you'll need to join our MixerLab Slack channel. An invitation will be sent to your Google account email at registration.
                </p>
                <p>
                  Please note, to be eligible for work, you must be located within the US and be at least 18 years old. 
                </p>
              </div>

              <div className="faq-view__qa-item">
              <h2>How do you monitor work quality?</h2>
              <p>
                We value <b>quality over quantity</b> of your work, and employ both automatic and manual reviews to ensure high standards. 
              </p>
            </div>
              
              <div className="welcome-view__qa-item">
                <h2>How do I get paid?</h2>
                <p>
                  We pay you via PayPal to the Google account email you use to register your Mixer account.
                </p>
              </div>
    
              <div className="welcome-view__qa-item">
                <h2>More questions?</h2>
                <p>
                  Check out our <a href="/faq">FAQ</a>.
                </p>
              </div>
              <FlexContainer>
                {this.renderLoginButtons()}
              </FlexContainer>
            </LowerContainerBox>
          </LowerContainer>
        </PageWrapper>
      );
    }
  }

export { LowerContainer, LowerContainerBox }
export default WelcomeScreen